'use client';

// Lightweight client wrapper that provides the standard site chrome
// (Header, Footer, theme, toast, router context) for server-rendered SEO
// hub pages. Unlike HomePageClient it does NOT render the homepage event
// list, so it can host arbitrary server content as children.

import { Toaster } from 'react-hot-toast';
import SafeBrowserRouter from '../SafeBrowserRouter';
import Header from '../Header';
import Footer from '../Footer';
import { useTheme } from '../../hooks/useTheme';
import { HeaderRouterProvider } from '../../contexts/HeaderRouterContext';
import { ProvinceDTO, PublicCategoryDTO } from '../../models/event';

interface Props {
  children: React.ReactNode;
  /** SSR-fetched by `HubPageShell` so the footer's SEO links ship in the
   * initial HTML on every hub landing. */
  categories?: PublicCategoryDTO[];
  provinces?: ProvinceDTO[];
}

export default function SeoLayoutClient({ children, categories, provinces }: Props) {
  useTheme();
  return (
    <HeaderRouterProvider>
      <SafeBrowserRouter>
        <div className="flex flex-col min-h-screen">
          <Header />
          <div>
            <Toaster />
          </div>
          <main className="relative flex-grow text-text-secondary overflow-visible bg-opacity-light">
            {children}
          </main>
          <Footer categories={categories} provinces={provinces} />
        </div>
      </SafeBrowserRouter>
    </HeaderRouterProvider>
  );
}
